import Api from 'services/api/Api';
import { ACCOUNT_ENDPOINT } from 'services/routes/constants';

const fakeDataListSuccess = {
  data: {
    data: [
      {
        id: 1,
        title: '【重要】Yahoo!広告新プラットフォーム対応のお知らせ',
        date_from: '2020-04-25 23:50:09',
        detail:
          '\nいつもアドエビスをご利用いただき、 誠にありがとうございます。\n\n この度、Yahoo!において「Yahoo!スポ ンサードサーチ」、「Yahoo!ディスプ レイアドネットワーク」から「Yahoo! 広告」へプラットフォームのリニュー アルに伴い、アドエビスの連携機能に おいても、新プラットフォームとの連 携が可能になります。\n\n 対象の連携サービスをご利用中のお客 様は、Yahoo!広告と再度、認証し直し ていただく必要がございますので、以 下内容をご確認の上、ご対応をお願い いたします。 \n\n対応予定日 \n2020年6月11日(木) \n※上記日程までは下記のご注意点をご 確認ください。 \n\n詳細な内容について \n対象の連携サービスや再認証の手順に つきましては、こちらをご確認くださ い。 \n\nご注意点 6月11日までにYahoo!側で新プラット フォームに切り替えた場合、リスティ ング連携・媒体データ連携にて正常に 連携ができません。 \nそのため、新プラットフォームに切り 替え済みのお客様については、6月11 日のリリースをお待ちいただくか、以 下の方法にてご対応いただけますと幸 いです。 \n\n◆対象機能\n リスティング連携、媒体データ連携 \n\n◆対応方法 \n以下いずれかの方法にてご対応くださ いませ。\n\n・旧画面に戻して連携する方法 新画面から旧画面に切り替えてキャン ペーンを作成し直した上で、連携を実 行してください。 ・手動登録する方法（リスティング連 携） 新画面では自動連係がご利用いただけ ないため、手動にて入稿用URLをご登 録ください。 ※ただしこの場合、コスト/表示回数は 自動で取り込むことができません。 本件につきまして、ご不明な点等がご ざいましたらエビス・サポートセン ターまでご連絡ください。',
        target_type: 1,
        display_type: 1,
        priority: 1,
        read: false,
      },
      {
        id: 2,
        title:
          '【重要】新型コロナウイルスの感染拡大防止に伴うサポートセンター営業大防止に伴うサポートセンター営業',
        date_from: '2020-04-25 23:50:09',
        detail:
          '\nいつもアドエビスをご利用いただき、 誠にありがとうございます。\n\n この度、Yahoo!において「Yahoo!スポ ンサードサーチ」、「Yahoo!ディスプ レイアドネットワーク」から「Yahoo! 広告」へプラットフォームのリニュー アルに伴い、アドエビスの連携機能に おいても、新プラットフォームとの連 携が可能になります。\n\n 対象の連携サービスをご利用中のお客 様は、Yahoo!広告と再度、認証し直し ていただく必要がございますので、以 下内容をご確認の上、ご対応をお願い いたします。 \n\n対応予定日 \n2020年6月11日(木) \n※上記日程までは下記のご注意点をご 確認ください。 \n\n詳細な内容について \n対象の連携サービスや再認証の手順に つきましては、こちらをご確認くださ い。 \n\nご注意点 6月11日までにYahoo!側で新プラット フォームに切り替えた場合、リスティ ング連携・媒体データ連携にて正常に 連携ができません。 \nそのため、新プラットフォームに切り 替え済みのお客様については、6月11 日のリリースをお待ちいただくか、以 下の方法にてご対応いただけますと幸 いです。 \n\n◆対象機能\n リスティング連携、媒体データ連携 \n\n◆対応方法 \n以下いずれかの方法にてご対応くださ いませ。\n\n・旧画面に戻して連携する方法 新画面から旧画面に切り替えてキャン ペーンを作成し直した上で、連携を実 行してください。 ・手動登録する方法（リスティング連 携） 新画面では自動連係がご利用いただけ ないため、手動にて入稿用URLをご登 録ください。 ※ただしこの場合、コスト/表示回数は 自動で取り込むことができません。 本件につきまして、ご不明な点等がご ざいましたらエビス・サポートセン ターまでご連絡ください。',
        target_type: 1,
        display_type: 1,
        priority: 1,
        read: false,
      },
      {
        id: 3,
        title: 'abc',
        date_from: '2020-04-25 23:50:09',
        detail: 'text',
        target_type: 1,
        display_type: 1,
        priority: 1,
        read: false,
      },
      {
        id: 4,
        title: 'abc',
        date_from: '2020-04-25 23:50:09',
        detail: 'text',
        target_type: 1,
        display_type: 1,
        priority: 1,
        read: false,
      },
    ],
  },
};

const NotificationsApiFactory = () => {
  const url = `${ACCOUNT_ENDPOINT}/system/notify`;
  return {
    getNotificationsList: async () => Api.get(url),
    getNotificationById: async (id) => Api.get(`${url}/${id}/`),
    putNotificationById: async (id, data = {}) =>
      Api.put(`${url}/${id}/`, data),
    getFakeNotificationList: async () => fakeDataListSuccess,
    sendTrackingNotifications: async (data) => Api.post(`${url}/track`, data),
  };
};

const NotificationsApi = NotificationsApiFactory();
export default NotificationsApi;
